<template>
  <section class="secCart checkout" id="secCart">
    <div class="mask" v-if="showMask" @click="hideAllModals"></div>

    <me-loading :loading="loading || !cartLoaded "></me-loading>

    <div class="container container--checkout">
      <div class="headerInfo">
        <div class="ttlBox">
          <h2 class="ttl">Carrinho de compras</h2>
          <span class="cartSize" v-if="items.length">
            <span>
              {{ items.length }} itens
            </span>

            <span class="tooltip -center tooltip--bottom tooltip--bottom-to-right tooltip--orange" data-tooltip="As etiquetas valem por 7 dias após geradas.
            Atente para a data de expiração de cada etiqueta."><i>!</i></span>
          </span>
        </div>

        <a href="javascript:;" class="btnClean" v-if="items.length" @click.prevent="openClearCart">Esvaziar carrinho</a>

        <div class="cartLimit" v-if="items.length">
          <p class="text-box -up">limite: <span>{{ limiteEnvios | shipment_limit }}</span></p>
          <a href="/painel/gerenciar/documentos" class="btnClean">aumentar limite</a>
        </div>

        <p class="subTtl subTtl--left">Selecione as etiquetas do carrinho que deseja pagar.</p>

        <div class="headerInfo--buttons">
          <a
            v-if="items.length"
            id="topGenerateMoreOrders"
            :href="$options.static.calculatorUrl"
            class="btnSubmit btnBorder margin-right"
          >
            Gerar mais etiquetas
          </a>

          <button
            v-if="items.length && showPixWith1ClickButton"
            id="topPixPayWith1Ckick"
            class="btnSubmit btnBorder margin-right"
            :disabled="disablePaymentButtons"
            @click="newCheckout('payWithOneClick')"
          >
            <svg class="ico"><use xlink:href="/images/svg-symbols.svg#pix-logo"></use></svg>
            <span>Pix: Pagar com 1 clique</span>
          </button>

          <button
            v-if="items.length"
            id="topFinishCart"
            class="btnSubmit btnColor"
            :disabled="disablePaymentButtons"
            @click="newCheckout()"
          >
            <span>Finalizar pagamento</span>
          </button>
        </div>
      </div>

      <div
        v-if="hasAlert"
        class="flex flex-col gap-4 mb-6"
      >
        <MuiAlertBox
          v-if="conciliationsDebts.show"
          title="Débitos de postagens conferidas"
          :description="conciliationsDebts.message"
          type="info"
        />

        <MuiAlertBox
          v-if="userDebts.show"
          title="Pendências por cobranças adicionais"
          :description="userDebts.message"
          type="info"
        />
      </div>

      <template v-if="items.length">
        <p class="chkTitle">Etiquetas</p>

        <div class="checkAllBox">
          <a
            href="javascript:;"
            class="btnClean"
            @click="uncheckAll"
            v-if="selecteds.length"
          >Desmarcar Todas</a>
          <a href="javascript:;" class="btnClean" @click="checkAll" v-else>Selecionar Todas</a>
        </div>

        <ul
          v-if="couponsLoaded"
          class="lstCheckout"
        >
          <template v-for="(item, index) in items">
            <cart-item
              :key="item.id"
              :index="index"
              :ticket-id="item.id"
              :is-selected="item.selected"
              :expiration-date="item.expired_at"
              @on-update-ticket='handleUpdateTicket'
            />
          </template>
        </ul>
      </template>

      <div class="emptyCart" v-if="cartLoaded && !items.length && debts <= 0">
        <p>Seu carrinho está vazio.</p>
        <a :href="$options.static.calculatorUrl" class="btnSubmit btnBorder"><span>Calcular fretes</span></a>
      </div>

      <div
        v-if="hasAlert && items.length"
        class="flex flex-col gap-4 mb-6"
      >
        <MuiAlertBox
          v-if="conciliationsDebts.show"
          title="Débitos de postagens conferidas"
          :description="conciliationsDebts.message"
          type="info"
        />

        <MuiAlertBox
          v-if="userDebts.show"
          title="Pendências por cobranças adicionais"
          :description="userDebts.message"
          type="info"
        />
      </div>

      <div class="footerInfo" v-if="items.length || debts > 0">
        <div class="totalBar">
          <div class="totalPrice totalPrice--total">
            <p class="price price--blue"><span>Total</span> <span>{{ total.price + total.debts | currency }}</span></p>
          </div>
          <template v-if="debts > 0">
            <span>=</span>
            <div class="totalPrice totalPrice--debits">
              <p class="price price--red"><span>Pendências</span> <span>{{ total.debts | currency }}</span></p>
            </div>
            <span>+</span>
            <div class="totalPrice totalPrice--item">
              <p class="price price--blue"><span>Etiquetas</span> <span>{{ total.price | currency }}</span></p>
            </div>
          </template>
        </div>

        <div class="buttons">
          <a
            v-if="items.length"
            id="firstGenerateMoreOrders"
            :href="$options.static.calculatorUrl"
            class="btnSubmit btnBorder margin-right"
          >
            Gerar mais etiquetas
          </a>

          <button
            v-if="showPixWith1ClickButton"
            id="firstBottomPixPayWith1Ckick"
            class="btnSubmit btnBorder margin-right"
            :disabled="disablePaymentButtons"
            @click="newCheckout('payWithOneClick')"
          >
            <svg class="ico"><use xlink:href="/images/svg-symbols.svg#pix-logo"></use></svg>
            <span>Pix: Pagar com 1 clique</span>
          </button>

          <button
            id="firstBottomFinishCart"
            class="btnSubmit btnColor"
            :disabled="disablePaymentButtons"
            @click="newCheckout()"
          >
            <span>Finalizar pagamento</span>
          </button>
        </div>
      </div>
    </div>

    <div class="fixedFooter" v-if="items.length" :class="fixedFooterClass">
      <div class="footerInfo">
        <div class="totalBar">
          <div class="totalPrice totalPrice--total">
            <p class="price price--blue"><span>Total</span> <span>{{ total.totalValue | currency }}</span></p>
          </div>
          <template v-if="debts > 0">
            <span>=</span>
            <div class="totalPrice totalPrice--debits">
              <p class="price price--red"><span>Pendências</span> <span>{{ total.debts | currency }}</span></p>
            </div>
            <span>+</span>
            <div class="totalPrice totalPrice--item">
              <p class="price price--blue"><span>Etiquetas</span> <span>{{ total.price | currency }}</span></p>
            </div>
          </template>
        </div>

        <div class="buttons">
          <a
            v-if="items.length"
            id="secondGenerateMoreOrders"
            :href="$options.static.calculatorUrl"
            class="btnSubmit btnBorder margin-right"
          >
            Gerar mais etiquetas
          </a>

          <button
            v-if="showPixWith1ClickButton"
            id="secondBottomPixPayWith1Ckick"
            class="btnSubmit btnBorder margin-right"
            :disabled="disablePaymentButtons"
            @click="newCheckout('payWithOneClick')"
          >
            <svg class="ico"><use xlink:href="/images/svg-symbols.svg#pix-logo"></use></svg>
            <span>Pix: Pagar com 1 clique</span>
          </button>

          <button
            id="secondBottomFinishCart"
            class="btnSubmit btnColor"
            :disabled="disablePaymentButtons"
            @click="newCheckout()"
          >
            <span>Finalizar pagamento</span>
          </button>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="modal modal--erro modal--small modal--center" v-if="modalClearCart">
        <div class="modal__header">
          <p>Esvaziar carrinho</p>

          <a href="javascript:;" class="closeModal"><svg class="ico" @click="hideModal('modalClearCart')"><use xlink:href="/images/svg-symbols.svg#close"></use></svg></a>
        </div>
        <div class="modal__content">
          <p>Tem certeza que deseja esvaziar o Carrinho de Compras?</p>
        </div>
        <div class="modal__footer">
          <a href="javascript:;" class="btnClear btnCancelar" @click="hideModal('modalClearCart')">Cancelar</a>
          <button name="Esvaziar Carrinho" type="button" class="btnBorder btnBorder--resend btnBorder--small" @click="clearCart()"><span>Esvaziar Carrinho</span></button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="modal modal--erro modal--small modal--center" v-if="finishPaymentFailed">
        <div class="modal__header">
          <p>Tente novamente</p>

          <a href="javascript:;" class="closeModal">
            <svg class="ico" @click="hideModal('finishPaymentFailed')">
              <use xlink:href="/images/svg-symbols.svg#close"></use>
            </svg>
          </a>
        </div>

        <div class="modal__content">
          <p>
            Desculpe, não conseguimos te direcionar para finalizar seu pagamento.
            Por favor, atualize a página e tente novamente ou <a :href="$options.static.supportUrl" title="Ir para o nosso suporte">clique aqui</a>
            para falar com alguém do nosso suporte.
          </p>
        </div>

        <div class="modal__footer">
          <button
            type="button"
            name="entendi"
            class="btnBorder btnBorder--resend btnBorder--small"
            @click="hideModal('finishPaymentFailed')"
          >
            <span>Entendi</span>
          </button>
        </div>
      </div>
    </transition>
    <me-stacked-toast ref="cartToast"/>
  </section>
</template>

<script>
  import CartItem from './cart/Item.vue';

  import Broadcast from 'commons/js/Broadcast';
  import MuiAlertBox from 'commons/js/components/atoms/MuiAlertBox';
  import verifyFeatureTester from 'commons/js/mixins/verifyFeatureTester'
  import { HTTP_OK } from 'commons/js/HttpStatusCodes';
  import { beautifyNumberToBRL } from 'commons/js/formatters/Currency';

  const alertDefaultMessage = `
    <p class="mt-4">Para continuar gerando etiquetas no Melhor Envio, você precisa regularizar o débito.</p>
    <p>Se você já quitou a pendência, pedimos que aguarde a confirmação do meio de pagamento.</p>
  `;

  export default {
    name: 'Cart',

    components : {
      'cart-item': CartItem,
      MuiAlertBox
    },

    mixins: [verifyFeatureTester],

    data() {
      return {
        loading: false,
        showMask: false,
        modalClearCart: false,
        finishPaymentFailed: false,
        limiteEnvios: '#',
        debts: 0,
        groups: 0,
        blocked: false,
        isFirstLoad: true,
        userID: null,
        user_debts: [],
        userEmail: '',
        items: [],
        synchedItems: [],
        coupons: [],
        balanceDebts: {},

        fixedFooterClass: '',

        meInformations: null,
        postPaidBlocked: false,
        cartLoaded: false,

        couponsLoaded: false
      }
    },

    filters: {
      currency: beautifyNumberToBRL,

      shipment_limit(value) {
        if (value === '#') return '...';
        if (!value) return 'nenhum envio';
        return value + ' envio' + (value > 1 ? 's' : '');
      }
    },

    computed: {
      total() {
        let result = {
          price: 0,
          discount: 0,
          debts: 0,
          totalValue: 0
        };
        for (let i = this.items.length - 1; i >= 0; i--) {
          let item = this.items[i];
          if (item.selected) {
            result.price += parseFloat(item.price);
            result.discount += parseFloat(item.discount);
          }
        }
        if (!this.blocked && this.debts > 0) {
          result.debts = this.debts;
        }
        result.totalValue = result.price + result.debts;

        return result;
      },

      selecteds() {
        return this.items.filter((e) => e.selected);
      },

      noItemsToPay() {
        const {
          selecteds,
          debts
        } = this;

        return (selecteds.length == 0 && debts <= 0)
      },

      hasLimits() {
        const {
          limiteEnvios,
          items
        } = this;

        return limiteEnvios >= items.length
      },

      isPostPaid() {
        return this.meInformations && this.meInformations.post_paid.is_post_paid;
      },

      isYapayTransparentActive() {
        if (!this.$store.getters.getPaymentMethods) {
          return false;
        }

        const yapayTransparent = this.$store.getters.getPaymentMethods.find(method => {
          return method.slug === 'yapay-transparente';
        });

        return !!yapayTransparent && yapayTransparent.status === 'available';
      },

      pixMinValue() {
        const pixPaymentMethod = this.$store.getters.getPaymentMethods.find(method => {
          return method.pix_min_value
        });

        if (pixPaymentMethod && pixPaymentMethod.pix_min_value) {
          return pixPaymentMethod.pix_min_value;
        }

        return 0;
      },

      isTotalLessThanPixMinValue() {
        const {pixMinValue, total: {totalValue}} = this;

        return totalValue < pixMinValue;
      },

      showPixWith1ClickButton() {
        try {
            const {isPostPaid, isYapayTransparentActive, isTotalLessThanPixMinValue} = this;

            return !isPostPaid && isYapayTransparentActive && !isTotalLessThanPixMinValue;
          } catch (error) {
            console.error(error);
          }
          return false;
      },

      disablePaymentButtons() {
        const {blocked, noItemsToPay, postPaidBlocked, cartLoaded} = this;

        return !!(blocked || noItemsToPay || postPaidBlocked || !cartLoaded);
      },

      conciliationsDebts() {
        if (!this.balanceDebts || !this.balanceDebts.conciliations || !this.balanceDebts.conciliations.debit) {
          return { show: false, difference: 0 };
        }

        const {
          debit: {total: totalDebit, count},
          credit: {total: totalCredit}
        } = this.balanceDebts.conciliations;

        const difference = totalDebit - totalCredit;

        return {
          show: count > 0 && difference > 0,
          difference,
          message: `
            <p>A conferência de postagem de um ou mais envios gerou um débito de ${beautifyNumberToBRL(difference)} na sua conta. Verifique os detalhes na aba <a href="painel/postagens-conferidas#diferencas" target="_blank">Diferenças</a> em Postagens conferidas.</p>
            ${alertDefaultMessage}
          `
        }
      },

      userDebts() {
        if (!this.balanceDebts || !this.balanceDebts.user_debts) {
          return { show: false };
        }

        const {difference: conciliationsDifference} = this.conciliationsDebts;
        const {count, total} = this.balanceDebts.user_debts;
        const hasConciliationCredit = conciliationsDifference < 0;
        const debtsDifference = hasConciliationCredit ? total + conciliationsDifference : total;

        return {
          show: count > 0 && debtsDifference > 0,
          message: `
            <p>Você tem um débito de ${beautifyNumberToBRL(debtsDifference)} gerado por cobranças adicionais. Confira os detalhes de cada envio na aba de <a href="painel/postagens-conferidas#pendencias">Pendências</a> em Postagens conferidas.</p>
            ${alertDefaultMessage}
          `
        }
      },

      hasAlert() {
        return this.conciliationsDebts.show || this.userDebts.show;
      }
    },

    async created() {
      await this.getDispatch();
      await this.loadUserData();
      await this.loadBalanceDebts();

      this.getMeInformations();

      await this.loadLimits();
      await this.loadCoupons();
      await this.loadDebts();

      await this.loadCart();

      this.checkStart();

      this.startWebSocket();

      window.addEventListener('scroll', this.handleScroll);
    },

    static: {
      supportUrl: MEConfig.get('dash.url') + '/ajuda',
      calculatorUrl: MEConfig.get('dash.url') + '/calculadora'
    },

    methods: {
      getDispatch() {
        return this.$store.dispatch('fetchPaymentMethods');
      },

      async loadBalanceDebts() {
        try {
          const {data, status} = await axios.get('/api/v2/me/debts/balance');

          if (status === HTTP_OK) {
            this.balanceDebts = data;
          }
        } catch (error) {
          console.error(error);
        }
      },

      async loadCoupons() {
        this.couponsLoaded = false;

        axios.get('/api/v2/me/coupons?per_page=100&available=true').then((response) => {
          if (response.data && response.data.data && response.data.data.length) {
            this.coupons = response.data.data;
          } else {
            this.coupons = [];
            for (let i = 0, length = this.items.length; i < length; i++) {
              let item = this.items[i];
              if (item && item.coupon) {
                let contains = this.coupons.filter((e) => {
                  return e.coupon.coupon === item.coupon.coupon;
                }).length > 0;
                if (!contains) {
                  this.coupons.push({
                    coupon: item.coupon,
                    times: 0
                  });
                }
              }
            }
          }

          this.couponsLoaded = true;
        });
      },

      async loadDebts() {
        this.loading = true;
        this.debts = 0;
        this.groups = 0;
        this.blocked = false;
        axios.get('/api/v2/me/conciliations/total').then((response) => {
          this.loading = false;
          let credits = parseFloat(response.headers['x-total-credit']);
          let debits = parseFloat(response.headers['x-total-debit']);
          let purchase = parseInt(response.headers['x-total-purchase']);
          let groups = parseInt(response.headers['x-total-groups']);
          if (isNaN(credits) || !isFinite(credits)) {
            credits = 0;
          }
          if (isNaN(debits) || !isFinite(debits)) {
            debits = 0;
          }
          if (isNaN(purchase) || !isFinite(purchase)) {
            purchase = 0;
          }
          if (isNaN(groups) || !isFinite(groups)) {
            groups = 0;
          }
          this.debts = debits - credits;
          this.groups = groups;
          this.blocked = purchase === 1;
          this.user_debts = response.data.debts;
        });
      },

      async loadCart() {
        this.loading = true;
        this.cartLoaded = false;

        await axios.get('/api/v2/me/cart?per_page=1000').then(async (response) => {
          this.loading = false;

          if (response.data && response.data.data && response.data.data.length) {
            this.items = response.data.data.map((e) => {
              e.selectedCoupon = e.coupon ? e.coupon.coupon : '';
              e.selected = false;
              e.errorClass = false;
              return e;
            });

            this.isFirstLoad = false;

            this.cartLoaded = true;
          }

          await this.syncCarts();
        });
      },

      async syncCarts() {
        this.cartLoaded = false;

        await axios.get('/api/v2/user-cart')
        .then(({data: {orders}}) => {
          if (!orders.length) {
            this.synchedItems = this.items.filter(item => item.selected).map(selected => selected.id);

            return;
          }

          this.items.forEach(item => {
            const ORDER = orders.find(order => order === item.id);

            if (ORDER && this.hasLimits && !item.expired_at) {
              item.selected = true;

              if(!this.ticketAlreadyExists(ORDER)) {
                this.synchedItems.push(ORDER);
              }
            } else {
              item.selected = false;
            }
          })
        });

        this.cartLoaded = true;
      },

      handleUpdateTicket(payload) {
        const cartItem = this.items.find(item => item.id === payload.id);

        cartItem.selected = !!(payload.checked);

        if (this.selecteds.length > this.limiteEnvios) {
          cartItem.errorClass = true;
          cartItem.selected = false;

          return;
        }

        cartItem.errorClass = false;

        if (payload.checked) {
          if(!this.ticketAlreadyExists(payload.id)) {
            this.synchedItems.push(payload.id)
          }

          return;
        }

        const TARGET_INDEX = this.synchedItems.indexOf(payload.id);

        if(TARGET_INDEX !== -1) {
          this.synchedItems.splice(TARGET_INDEX, 1)
        }

      },

      ticketAlreadyExists(ticketId) {
        return this.synchedItems.some(ticket => ticket === ticketId);
      },

      async newCheckout(isPixWithOneClick) {
        if (!this.blocked && (this.selecteds.length || this.debts > 0)) {
          try {
            const {status} = await axios.post('/api/v2/user-cart', {
              orders: this.synchedItems,
              is_one_click: !!isPixWithOneClick
            });

            if (status === HTTP_OK) {
              window.location = MEConfig.get('dash.url') + '/checkout';
            }
          } catch (error) {
            console.error(error);
            this.showModal('finishPaymentFailed')
          }
        }
      },

      async loadLimits() {
        await axios.get('/api/v2/me/limits').then((response) => {
          if (response.data && response.data) {
            this.limiteEnvios = response.data.shipments_available;
          }
        });
      },

      async clearCart() {
        this.hideModal('modalClearCart');

        try {
          const {status, data} = await axios.post('/api/v2/me/cart-clear');
          if (status === HTTP_OK) {
            let toastContent = 'Todos as suas etiquetas foram removidas do carrinho.';

            if (data && data.message) {
              toastContent = data.message;
            }

            this.$refs.cartToast.createToast(toastContent, 'success')
            this.items= [];
            window.$me_nav('clear-cart');
          }
        } catch(error) {
          this.$refs.cartToast.createToast('Ocorreu um erro ao tentar limpar o carrinho. Tente novamente.', 'danger')
        } finally {
          setTimeout(() => {
            this.loadCoupons();
          }, 1000);
        }
      },

      removeItem(index) {
        axios.delete('/api/v2/me/cart/' + this.items[index].id).then(() => {
          this.loadCoupons();
        });
        this.items.splice(index, 1);
        window.$me_nav('decrement-cart');
      },

      showModal(modal) {
        this[modal] = true;
        this.showMask = true;
      },

      hideModal(modal) {
        this[modal] = false;
        this.showMask = false;
      },

      hideAllModals() {
        this.showMask = false;
        this.modalClearCart = false;
        this.finishPaymentFailed = false;
      },

      openClearCart() {
        if (this.items.length >= 1) {
          this.showModal('modalClearCart');
        }
      },

      finishCart() {
        if (!this.blocked && (this.selecteds.length || this.debts > 0)) {
          let form = document.createElement('form');
          form.method = 'POST';
          form.action = '/checkout';
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = '_token';
            input.value = MEConfig.get('csrf-token');
            form.appendChild(input);
          this.selecteds.forEach((item) => {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'orders[]';
            input.value = item.id;
            form.appendChild(input);
          });
          document.body.appendChild(form);
          form.submit();
        }
      },

      checkAll() {
        for (let i = 0, length = this.items.length; i < length; i++) {
          if (!this.items[i].expired_at) {
            if(i < this.limiteEnvios) {
              this.items[i].selected = true
            } else {
              this.items[i].errorClass = true;
              this.items[i].selected = false;
            }

            if (!this.isFirstLoad) {
              if (this.items[i].selected && !this.ticketAlreadyExists(this.items[i].id)) {
                this.synchedItems.push(this.items[i].id);
              }
            }
          }
        }
      },

      uncheckAll() {
        for (let i = 0, length = this.items.length; i < length; i++) {
          this.items[i].selected = false;
          this.items[i].errorClass = false;
        }

        this.synchedItems.length = 0;
      },

      checkStart() {
        if (this.hasLimits) {
          this.checkAll();
        }
      },

      handleScroll(e) {
        let doc = document.documentElement;
        let top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
        let bottom = document.body.clientHeight - window.innerHeight - 400;
        this.fixedFooterClass = (top > 156 && top < bottom) ? 'sticky' : '';
      },

      linked_tracking(value) {
        let matches = String(value).match(/\(rastreio\s(.*)\)/);
        if (matches && matches.length === 2) {
          return value.replace(matches[1], '<a href="https://www.melhorrastreio.com.br/rastreio/' + matches[1] + '" target="_blank" style="color: #3598dc; text-decoration: none; font-weight: bold;">' + matches[1] + '</a>');
        }
        return value;
      },

      getMeInformations() {
        this.loading = true;

        axios.get('/api/v2/me')
          .then((response) => {
            if (response.data) {
              this.meInformations = response.data;
              this.userEmail = this.meInformations.email;
              this.addEmailToDataLayer();
              if (this.meInformations.post_paid.is_blocked) {
                this.postPaidBlocked = true;
              }
            }
          })
          .finally(() => {
            this.loading = false;
          })
      },

      startWebSocket() {
        const channel = Broadcast.user(MEConfig.get('user.id'));

        channel.listen('.cart.purchase_associated', () => {
          location.reload();
        })
      },
      addEmailToDataLayer() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'email': this.userEmail
        });
      }
    }
  }
</script>
